import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=54748a80&scoped=true&lang=pug&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54748a80",
  null
  
)

export default component.exports